import { Inject, Injectable } from '@angular/core';
import { WebStorageUtility } from './../../../utilities/web-storage/web-storage.utility';
import { WindowRef } from './../../windowRef';

@Injectable()
export class LocalStorageService extends WebStorageUtility<string> {
  constructor(private windowRef: WindowRef, @Inject('Rollbar') private Rollbar) {
    super(windowRef.nativeWindow.localStorage, Rollbar);
  }
}
